export interface CondicionFiscalOption {
  label: string;
  value: string;
}

const getCondicionesFiscales = (): CondicionFiscalOption[] => {
  let result: CondicionFiscalOption[] = [
    {
      label: "Monotributista",
      value: "Monotributista",
    },
    {
      label: "Responsable Inscripto",
      value: "ResponsableInscripto",
    },
    {
      label: "Iva Exento",
      value: "IvaExento",
    },
    {
      label: "Consumidor Final",
      value: "ConsumidorFinal",
    },
  ];

  return result;
};

export default getCondicionesFiscales;
